export enum HotelFareDetailParams {
  hotelId = 'h',
  hash = 'hash'
}
